// eslint-disable-next-line no-shadow
export const enum ChartMode {
	all = 'all',
	detail = 'detail',
}
